//list of available filter keys

const filterKeyReceivedData = {
  PERIOD_MONTH: "period_month",
  PERIOD_WEEK: "period_date",
  STATUS: "status",
};

const filterKeyWithdrawData = {
  PERIOD_MONTH: "period_month",
  PERIOD_WEEK: "period_date",
  STATUS: "status",
};

export { filterKeyReceivedData, filterKeyWithdrawData };
